import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from './utils/cn';

const loadingDotsVariants = cva('flex items-center gap-1', {
  variants: {
    size: {
      sm: '[&>span]:h-1 [&>span]:w-1',
      default: '[&>span]:h-1.5 [&>span]:w-1.5',
      lg: '[&>span]:h-2 [&>span]:w-2',
    },
  },
  defaultVariants: {
    size: 'default',
  },
});

export interface LoadingDotsProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof loadingDotsVariants> {}

function LoadingDots({ className, size, ...props }: LoadingDotsProps) {
  return (
    <div
      role="status"
      className={cn(loadingDotsVariants({ size }), className)}
      {...props}
    >
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="rounded-full bg-current"
          style={{
            animation: 'dot-bounce 1.4s ease-in-out infinite',
            animationDelay: `${i * 0.16}s`,
          }}
        />
      ))}
      <span className="sr-only">Loading...</span>
    </div>
  );
}

export { LoadingDots, loadingDotsVariants };
